import React, { SyntheticEvent } from 'react';

import { useTranslation } from 'react-i18next';

import {
    GenerateMeasurement,
    useGetListProjectMeasurementActionsQuery,
} from '@features/GenerateMeasurement';
import { Flex, Icon, Skeleton, UiButton } from '@shared/ui';

import cls from './MeasurementsInterface.module.css';
import { useMeasurementsInterface } from '../lib/hooks/useMeasurementsInterface';

interface MeasurementsInterfaceProps {
    onAddMeasurementsList: () => void;
    isLoadingMeasurementsData?: boolean;
}

export const MeasurementsInterface = ({
    onAddMeasurementsList,
    isLoadingMeasurementsData,
}: MeasurementsInterfaceProps) => {
    useMeasurementsInterface();

    const { t } = useTranslation();

    const { data, isLoading } = useGetListProjectMeasurementActionsQuery();

    const isNeedLoadActions = !data && isLoading;

    return (
        <Flex direction="row" gap={8} className={cls.MeasurementsInterface}>
            {isNeedLoadActions && isLoadingMeasurementsData ? (
                <Skeleton width={130} height={28} />
            ) : (
                <>
                    {data?.addMeasurement && (
                        <UiButton
                            className={cls.ButtonFont}
                            onClick={(e) => {
                                e.stopPropagation();
                                onAddMeasurementsList();
                            }}
                            btnText={t('MeasurementsInterface.return.Flex.UiButton.btnText')}
                            startIcon={<Icon iconName="plus" />}
                        />
                    )}
                </>
            )}
            {isNeedLoadActions && isLoadingMeasurementsData ? (
                <Skeleton width={160} height={28} />
            ) : (
                <>{data?.generateMeasurement && <GenerateMeasurement />}</>
            )}
        </Flex>
    );
};
